module.exports = {
      id: "ic-dot-normal-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-dd6387.smartcharts.svg#ic-dot-normal-usage",
      toString: function () {
        return this.url;
      }
    }